import { useContext, useEffect, useState, useRef } from 'react'
import { IResponse } from 'interfaces'
import useFetch from 'hooks/useFetch'
import { UserContext } from 'context/userContext'
import { Icon } from 'assets/index'
import {
  InfoCard,
  Loading,
  ResumeInputCard,
  DoclistHandle,
  Path,
  ResumeSelectCard,
} from 'components/index'
import { Theme } from 'styles/Themes'
import {
  optionsLevels,
  moneyToNumber,
  numberToMoney,
  hasAccess,
} from 'helper/utils'
import { useStorage } from 'hooks'
import { Container } from './style'
import DistribuicaoTable from './DistribuicaoTable'

const cleanDocument = (value: string) => {
  return value.replace(/[.\-\/]/g, '')
}

const optionsTypePix = [
  { value: 'CPF', label: 'CPF' },
  { value: 'CNPJ', label: 'CNPJ' },
  { value: 'PHONE', label: 'Telefone' },
  { value: 'EMAIL', label: 'E-mail' },
  { value: 'EVP', label: 'Aleatória' },
]

export default function DetalhesEmpreendimento() {
  const { selectedId, loading, setLoading, formData } = useContext(UserContext)
  const [user] = useStorage('User')
  const [data, setData] = useState<any>({})
  const [documentList, setDocumentList] = useState<any>([])
  const text = useRef()
  formData.current = new FormData()
  const api = useFetch(`/gestor/enterprise?id=${selectedId.current}`)
  const [pixMask, setPixMask] = useState<string>()

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true)
        const response: IResponse = await api.fetch('get')
        console.log('RESPONSE', response)
        if (response.fail) throw new Error(response.errors.message)
        setData(response.data.data)
        const dl = response.data.data.documentList.map((item: any) => ({
          name: item.type,
          file: item.file,
          type: 'document',
        }))
        const cl = response.data.data.contractList.map((item: any) => ({
          name: item.type,
          file: item.file,
          type: 'contract',
        }))
        const atta = response.data.data.attachmentList.map((item: any) => ({
          name: item.type,
          file: item.file,
          type: 'attachment',
        }))
        setDocumentList([...dl, ...cl, ...atta])
        setLoading(false)
      } catch (err: any) {
        console.log('err', err)
        setLoading(false)
      }
    }

    fetchData()
  }, [])

  const handleChangeData = async (key: string, value: any, isPix?: boolean) => {
    const form = new FormData()
    if (isPix) {
      const keyUpdate = { ...data.pix }
      keyUpdate[key] = value

      form.append('pix', JSON.stringify(keyUpdate))
    } else {
      form.append(key, value)
    }
    console.log('FORM', form)

    try {
      const response: IResponse = await api.fetch('put', form)
      // console.log('EMAIL', response.data, key, value, form.get('email'))
      if (key === 'address[postalCode]') {
        setData((prev: any) => ({
          ...prev,
          address: {
            ...prev.address,
            city: response.data.city,
            state: response.data.state,
          },
        }))
        // Troca valores de cidade e stado de acordo com o cep quando trocado
      }
      if (response.fail) throw new Error(response.errors.message)
    } catch (err: any) {
      console.log('err', err)
    }
  }

  if (loading) return <Loading modal />
  return (
    <Container>
      <Path className="path">
        <span className="path">
          {'Gestão de produtos > Empreendimentos  > Detalhes do empreendimento'}
        </span>
      </Path>
      <h1 className="detalhes-captacao-title">{data?.name}</h1>
      <div className="status-card-captacao">
        <img
          className="status-card-captacao-img"
          src={Icon('clock.svg')}
          alt="status icon"
        />
        <span>Próximos empreendimentos</span>
      </div>

      <div className="status-card-container-cards">
        <h1 className="detalhes-captacao-title">Dados do Empreendimento</h1>
        <InfoCard icon={Icon('calendar.svg')} value={data?.createdAt}>
          Data de criação
        </InfoCard>
        <InfoCard icon={Icon('calendar.svg')} value={data?.tradeAt}>
          Data da ativação
        </InfoCard>
        <InfoCard icon={Icon('calendar.svg')} value={data?.startedAt}>
          Data de liberação
        </InfoCard>
        <ResumeInputCard
          clickable={hasAccess('edit-enterprise-name')}
          id="edit-enterprise-name"
          names="resumo-meta-captacao"
          icon="shield.svg"
          placeholder={data?.name}
          handleChangeInput={(e: any) => (text.current = e)}
          onClick={() => handleChangeData('name', text.current)}
        >
          Nome do empreendimento
        </ResumeInputCard>
        <ResumeInputCard
          // clickable={['OWNER', 'DIRECTOR'].includes(optionsLevels[user.level])}
          clickable={hasAccess('edit-enterprise-shortName')}
          id="edit-enterprise-shortName"
          names="resumo-meta-captacao"
          icon="shield.svg"
          placeholder={data?.shortName}
          small
          handleChangeInput={(e: any) => (text.current = e)}
          onClick={() => handleChangeData('shortName', text.current)}
        >
          Nome resumido
        </ResumeInputCard>
        <ResumeInputCard
          // clickable={['OWNER', 'DIRECTOR'].includes(optionsLevels[user.level])}
          clickable={hasAccess('edit-enterprise-tick')}
          id="edit-enterprise-tick"
          names="resumo-meta-captacao"
          icon="shield.svg"
          placeholder={data?.tick}
          medium
          handleChangeInput={(e: any) => (text.current = e)}
          onClick={() => handleChangeData('tick', text.current)}
        >
          Sigla do empreendimento
        </ResumeInputCard>

        <ResumeInputCard
          clickable={['OWNER', 'DIRECTOR'].includes(optionsLevels[user.level])}
          // clickable={hasAccess('edit-enterprise-tick')}
          id="edit-enterprise-document"
          names="resumo-meta-captacao"
          icon="shield.svg"
          placeholder={data?.document}
          medium
          isMask="00.000.000/0000-00"
          handleChangeInput={(e: any) => (text.current = e)}
          onClickOK={() =>
            handleChangeData('document', cleanDocument(String(text.current)))
          }
        >
          CNPJ
        </ResumeInputCard>
        <ResumeInputCard
          clickable={['OWNER', 'DIRECTOR'].includes(optionsLevels[user.level])}
          id="edit-enterprise-email"
          names="resumo-meta-captacao"
          icon="shield.svg"
          placeholder={data?.email}
          medium
          handleChangeInput={(e: any) => (text.current = e)}
          onClickOK={() => handleChangeData('email', text.current)}
        >
          Email
        </ResumeInputCard>
        <ResumeInputCard
          clickable={['OWNER', 'DIRECTOR'].includes(optionsLevels[user.level])}
          // clickable={hasAccess('edit-enterprise-tick')}
          id="edit-enterprise-cellphone"
          names="resumo-meta-captacao"
          icon="shield.svg"
          placeholder={data?.cellphone}
          medium
          isMask="(00) 00000-0000"
          handleChangeInput={(e: any) => (text.current = e)}
          onClick={() => handleChangeData('cellphone', text.current)}
        >
          Telefone
        </ResumeInputCard>
      </div>
      <div className="status-card-container-cards">
        <h1 className="detalhes-captacao-title"> Detalhes do Empreendimento</h1>

        <ResumeInputCard
          clickable={false}
          id="edit-enterprise-value"
          // clickable={['OWNER', 'DIRECTOR'].includes(optionsLevels[user.level])}
          blocks={{ num: { mask: String } }}
          names="resumo-meta-captacao"
          icon="money.svg"
          placeholder={data?.meterTotal}
          semi
          handleChangeInput={(e: any) => (text.current = e)}
          onClick={() => handleChangeData('value', moneyToNumber(text.current))}
        >
          M² do empreendimento
        </ResumeInputCard>
        <ResumeInputCard
          clickable={false}
          id="edit-enterprise-meterValue"
          // clickable={['OWNER', 'DIRECTOR'].includes(optionsLevels[user.level])}
          blocks={{ num: { mask: String } }}
          names="resumo-meta-captacao"
          icon="money.svg"
          placeholder={data?.meterValue}
          semi
          handleChangeInput={(e: any) => (text.current = e)}
          onClick={() => handleChangeData('value', moneyToNumber(text.current))}
        >
          Preço do M²
        </ResumeInputCard>
        <ResumeInputCard
          clickable={false}
          id="edit-enterprise-value"
          // clickable={['OWNER', 'DIRECTOR'].includes(optionsLevels[user.level])}
          isMask={'R$ num'}
          blocks={{ num: { mask: String } }}
          names="resumo-meta-captacao"
          icon="money.svg"
          placeholder={`R$ ${numberToMoney(data?.value)}`}
          semi
          handleChangeInput={(e: any) => (text.current = e)}
          onClick={() => handleChangeData('value', moneyToNumber(text.current))}
        >
          Preço da unidade
        </ResumeInputCard>

        <ResumeInputCard
          clickable={false}
          id="edit-enterprise-quotaValue"
          // clickable={['OWNER', 'DIRECTOR'].includes(optionsLevels[user.level])}
          isMask={'R$ num'}
          blocks={{ num: { mask: String } }}
          names="resumo-meta-captacao"
          icon="money.svg"
          placeholder={`R$ ${numberToMoney(data?.vgv)}`}
          semi
          handleChangeInput={(e: any) => (text.current = e)}
          onClick={() =>
            handleChangeData('quotaValue', moneyToNumber(text.current))
          }
        >
          VGV
        </ResumeInputCard>
      </div>

      <div className="status-card-container-cards">
        <h1 className="detalhes-captacao-title">Disponibilidade total</h1>

        <ResumeInputCard
          clickable={hasAccess('edit-enterprise-amount')}
          id="edit-enterprise-amount"
          // clickable={['OWNER', 'DIRECTOR'].includes(optionsLevels[user.level])}

          names="resumo-meta-captacao"
          icon="cash.svg"
          placeholder={data?.amount}
          small
          handleChangeInput={(e: any) => (text.current = e)}
          onClick={() => handleChangeData('amount', text.current)}
        >
          Número de unidades
        </ResumeInputCard>
        <ResumeInputCard
          clickable={false}
          names="resumo-meta-captacao"
          icon="cash.svg"
          placeholder={data?.unityAvailable}
          medium
        >
          Unidades disponíveis
        </ResumeInputCard>
        <InfoCard icon={Icon('cash.svg')} value={data?.quotaAmount}>
          Total de cotas
        </InfoCard>
        <InfoCard
          width={190}
          icon={Icon('cash.svg')}
          value={data?.circulatingSupply}
        >
          Cotas vendidas
        </InfoCard>
        <ResumeInputCard
          clickable={false}
          filter={{ filter: 'brightness(0) invert(1)' }}
          names="resumo-meta-captacao"
          icon="cash.svg"
          placeholder={data?.available}
          small
        >
          Cotas disponíveis
        </ResumeInputCard>
      </div>

      <div className="status-card-container-cards">
        <h1 className="detalhes-captacao-title">Endereço</h1>
        <ResumeInputCard
          id="edit-enterprise-postalCode"
          clickable={['OWNER', 'DIRECTOR'].includes(optionsLevels[user.level])}
          isMask="00000-000"
          names="resumo-meta-captacao"
          icon="pin.svg"
          placeholder={data?.address?.postalCode}
          small
          handleChangeInput={(e: any) => (text.current = e)}
          onClickOK={() =>
            handleChangeData(
              'address[postalCode]',
              cleanDocument(String(text.current))
            )
          }
        >
          CEP
        </ResumeInputCard>
        <InfoCard
          width={190}
          icon={Icon('pin.svg')}
          value={data?.address?.state}
        >
          Estado
        </InfoCard>
        <InfoCard
          width={190}
          icon={Icon('pin.svg')}
          value={data?.address?.city}
        >
          Cidade
        </InfoCard>
        <ResumeInputCard
          id="edit-enterprise-postalCode"
          clickable={['OWNER', 'DIRECTOR'].includes(optionsLevels[user.level])}
          names="resumo-meta-captacao"
          icon="pin.svg"
          placeholder={data?.address?.province}
          small
          handleChangeInput={(e: any) => (text.current = e)}
          onClickOK={() => handleChangeData('address[province]', text.current)}
        >
          Bairro
        </ResumeInputCard>
        <ResumeInputCard
          id="edit-enterprise-address"
          clickable={['OWNER', 'DIRECTOR'].includes(optionsLevels[user.level])}
          names="resumo-meta-captacao"
          icon="pin.svg"
          placeholder={data?.address?.address}
          small
          handleChangeInput={(e: any) => (text.current = e)}
          onClickOK={() => handleChangeData('address[address]', text.current)}
        >
          Rua
        </ResumeInputCard>
        <ResumeInputCard
          id="edit-enterprise-number"
          clickable={['OWNER', 'DIRECTOR'].includes(optionsLevels[user.level])}
          names="resumo-meta-captacao"
          icon="pin.svg"
          placeholder={data?.address?.number}
          small
          handleChangeInput={(e: any) => (text.current = e)}
          onClickOK={() => handleChangeData('address[number]', text.current)}
        >
          Número
        </ResumeInputCard>
        <ResumeInputCard
          // clickable={hasAccess('edit-enterprise-quotaValue')}
          id="edit-enterprise-complement"
          clickable={['OWNER', 'DIRECTOR'].includes(optionsLevels[user.level])}
          names="resumo-meta-captacao"
          icon="pin.svg"
          placeholder={data?.address?.complement}
          small
          handleChangeInput={(e: any) => (text.current = e)}
          onClickOK={() =>
            handleChangeData('address[complement]', text.current)
          }
        >
          Complemento
        </ResumeInputCard>
      </div>

      <div className="status-card-container-cards">
        <h1 className="detalhes-captacao-title">Dados bancários</h1>

        <ResumeInputCard
          clickable={['OWNER', 'DIRECTOR'].includes(optionsLevels[user.level])}
          id="edit-enterprise-quotaValue"
          names="resumo-meta-captacao"
          icon="lock_open.svg"
          placeholder={data?.pix?.institution}
          small
          handleChangeInput={(e: any) => (text.current = e)}
          onClickOK={() => handleChangeData('institution', text.current, true)}
        >
          Banco
        </ResumeInputCard>

        <ResumeInputCard
          clickable={['OWNER', 'DIRECTOR'].includes(optionsLevels[user.level])}
          id="edit-enterprise-account"
          names="resumo-meta-captacao"
          icon="lock_open.svg"
          isMask="0000000000000000"
          placeholder={data?.pix?.account}
          small
          handleChangeInput={(e: any) => (text.current = e)}
          onClickOK={() => handleChangeData('account', text.current, true)}
        >
          Conta
        </ResumeInputCard>

        <ResumeInputCard
          clickable={['OWNER', 'DIRECTOR'].includes(optionsLevels[user.level])}
          id="edit-enterprise-branch"
          names="resumo-meta-captacao"
          icon="lock_open.svg"
          isMask="0000000000000000"
          placeholder={data?.pix?.branch}
          small
          handleChangeInput={(e: any) => (text.current = e)}
          onClickOK={() => handleChangeData('branch', text.current, true)}
        >
          Agência
        </ResumeInputCard>

        <ResumeSelectCard
          id="editar-card-info-cliente-pixType"
          key={data?.pix?.type || 'empty'}
          name={
            optionsTypePix.find((i) => i.value === data?.pix?.type)?.label ??
            'Selecionar'
          }
          options={optionsTypePix}
          text=""
          handleChange={(e: any) => {
            const pixType = e.value

            if (pixType === 'PHONE') {
              setPixMask('+55 (00) 00000-0000')
            }
            if (pixType === 'CPF') {
              setPixMask('000.000.000-00')
            }
            if (pixType === 'CNPJ') {
              setPixMask('00.000.000/0000-00')
            }
            if (pixType === 'EMAIL' || pixType === 'EVP' || !pixType) {
              setPixMask('')
            }
            handleChangeData('type', pixType, true)
            setData((prev: any) => ({
              ...prev,
              pix: {
                ...prev.pix,
                type: pixType,
              },
            }))
          }}
          icon="lock_open.svg"
          small
        >
          Tipo chave Pix
        </ResumeSelectCard>

        <ResumeInputCard
          clickable={hasAccess('edit-enterprise-quotaValue')}
          id="edit-enterprise-key"
          names="resumo-meta-captacao"
          icon="lock_open.svg"
          placeholder={data?.pix?.key}
          isMask={pixMask}
          small
          handleChangeInput={(e: any) => (text.current = e)}
          onClick={() => handleChangeData('key', text.current, true)}
        >
          Chave PIX
        </ResumeInputCard>
      </div>
      <div className="distribution-container ">
        <h1 className="detalhes-captacao-title">Distribuição</h1>
        <DistribuicaoTable data={data.distribution} />
      </div>

      <h1 className="detalhes-captacao-title">Jurídico</h1>
      <h1 className="detalhes-captacao-title">Anexos das Captações</h1>
      <DoclistHandle
        readonly={
          !hasAccess('add-document-enterprise')
          // !['OWNER', 'DIRECTOR'].includes(optionsLevels[user.level]) ||
          // user?.permission === 'READ'
        }
        documentList={documentList}
        onChange={async (form) => {
          try {
            const response: IResponse = await api.fetch('put', form)
            if (response.fail) throw new Error(response.errors.message)
          } catch (err: any) {
            console.log('err', err)
          }
        }}
      />
    </Container>
  )
}
